export const tag2018Q2 = '$2018Q2';
export const tag2018Q3 = '$2018Q3';
export const tagServer = 'server';
export const tagMeta = 'meta';



// WEBPACK FOOTER //
// ./src/components/atoms/Feature/Tags.js